<template>
  <v-autocomplete
    v-model="selectedOption"
    v-bind="$props"
    :item-text="itemText"
    :item-value="itemValue"
    append-icon="arrow_drop_down"
    @change="valueChanged"
    :flat="styleFlat"
  />

</template>

<script>
export default {
    name: "PsSelect",
    props: {
        multiple: {
            type: Boolean,
            default: false,
            required: false
        },
        items: {
            type: Array,
            required: true
        },
        currentValue: {
            type: String || Number || Array, // Array if set to multiple.
            required: true,
            default: () => { return "" }
        },
        cell: {
            type: Object,
            required: false,
            default: null
        },
        styleFlat: {
            type: Boolean,
            required: false,
            default: false
        },
        styleSolo: {
            type: Boolean,
            required: false,
            default: false
        },
        styleDense: {
            type: Boolean,
            required: false,
            default: false
        },
        styleOutlined: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            selectedOption: null
        };
    },
    mounted () {
        this.selectedOption = !this.multiple ? this.value || this.currentValue : this.value == null ? this.currentValue : [this.value];
    },
    methods: {
        itemText: item => item.name || item.label,
        itemValue: item => item.tag || item.id || item.siteTag,
        valueChanged: function (e) {

            this.$emit("input", e.toString());
            this.$emit("change-event", e);

            if (this.cell !== null) {
                this.cell.setValue(e.toString());
                window.Bus.$emit("cellValueChanged", [this.cell]);
            }
        }
    }
};
</script>

<style>
.v-select__selection.v-select__selection--comma {
    border: 1px solid #ccc;
    border-radius: 5px;
    background: #efefef;
    padding: 0 5px;
    font-size: 11px;
}
.p4-report .v-list-item__content{
    padding: 5px 0;
}
.p4-report .v-list-item__title{
    font-size: 1em;
    line-height: 1em;
}
.p4-report .v-list-item__action {
    margin:0px;
    min-width:none;
}
</style>